// Default battery sizes in kWh for Tesla models
const defaultTeslaBatterySizes = {
  "Model 3": 75,
  "Model S": 100,
  "Model X": 100,
  "Model Y": 75
};

// Charger speeds in kW
const chargerSpeeds = {
  home: 7.4,         // Level 2 home charger
  supercharger: 150, // Tesla Supercharger
  ccs: 50            // CCS Charger (50 kW)
};

// Function to set the default battery size when a model is selected
function setDefaultBatterySize() {
  const model = document.getElementById("tesla-model").value;
  const defaultBatterySize = defaultTeslaBatterySizes[model];
  document.getElementById("battery-size").value = defaultBatterySize; // Set default value
}

// Function to calculate charging time, cost, and range
function calculateChargingCost() {
  const model = document.getElementById("tesla-model").value;
  const chargerType = document.getElementById("charger-type").value;
  const electricityRate = parseFloat(document.getElementById("electricity-rate").value);
  const currentCharge = parseFloat(document.getElementById("current-charge").value);

  // Use the battery size input by the user
  const batterySize = parseFloat(document.getElementById("battery-size").value);
  const chargerSpeed = chargerSpeeds[chargerType]; // Get charger speed based on charger type
  const chargeNeeded = batterySize * (1 - (currentCharge / 100)); // Battery capacity needed to charge

  const chargingTime = chargeNeeded / chargerSpeed; // Calculate hours to charge
  const chargingCost = chargeNeeded * electricityRate; // Calculate cost in €
  const rangeAdded = chargeNeeded * (500 / batterySize); // Approximate km added (based on full range)

  // Display results
  document.getElementById("charging-results").innerHTML = `
    <h3>Charging Results:</h3>
    <p>Charging Time: ${chargingTime.toFixed(2)} hours</p>
    <p>Charging Cost: €${chargingCost.toFixed(2)}</p>
    <p>Range Added: ${rangeAdded.toFixed(2)} km</p>
  `;
}

